import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '../theming';

export type FooterItemProps = {
  children: React.ReactNode;
};

const StyledFooterItem = styled.div`
  display: inline-flex;
  &:last-child {
    a::after {
      content: ' ';
    }
  }
`;

export const FooterItem = ({ children }: FooterItemProps): JSX.Element => (
  <StyledFooterItem className="FooterItem">{children}</StyledFooterItem>
);

FooterItem.propTypes = {
  children: PropTypes.node.isRequired,
};
